import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import i18n from '../../../../lang/idiomas'
import Spinner from '../../../layout/Spinner'
import { getWebPresupuestos } from '../libs/HandleWebPresupuestos'
import WebPresupuestosDetalle from './WebPresupuestosDetalle'
import WebPresupuestosFilters from './WebPresupuestosFilters'
import Paginator from './filters/Paginator'

const WebPresupuestos = props => {
  const dispatch = useDispatch()
  // Filtros
  const [fechaDesde, setFechaDesde] = useState('')
  const [fechaHasta, setFechaHasta] = useState('')
  const [sortBy, setSortBy] = useState('')
  const [id, setID] = useState()
  const [page, setPage] = useState(1)
  const [next, setNext] = useState()
  const [previous, setPrevious] = useState()
  const [limit, setLimit] = useState(12)

  // Manejo componente
  const [loading, setLoading] = useState(false)
  const [numeroRegistros, setNumeroRegistros] = useState(false)
  const [verDetalle, setVerDetalle] = useState(false)
  const [presupuestos, setPresupuestos] = useState([])
  const [presupuestoSeleccionado, setPresupuestoSeleccionado] = useState()
  const [isSaved, setIsSaved] = useState(false)

  const pedido = useSelector(state => state.pedidos.pedido)
  const precios = useSelector(state => state.precios.precio)

  let isNew = window.location.search.includes('?new')

  useEffect(() => {
    if (isNew) {
      setVerDetalle(true)
      setID(pedido?.id_pedido)
    }
  }, [pedido])

  useEffect(() => {
    if (!window.location.search.includes('?new')) {
      setVerDetalle(false)
      setID()
    }
  }, [window.location.search])

  useEffect(() => {
    setPage(page)
  }, [verDetalle])

  useEffect(() => {
    if (isNew) {
      if (id) {
        dispatch(
          getWebPresupuestos(
            fechaDesde,
            fechaHasta,
            sortBy,
            id,
            page,
            limit,
            setPresupuestos,
            setNumeroRegistros,
            setLoading,
            setNext,
            setPrevious,
          ),
        )
      }
    } else {
      dispatch(
        getWebPresupuestos(
          fechaDesde,
          fechaHasta,
          sortBy,
          id,
          page,
          limit,
          setPresupuestos,
          setNumeroRegistros,
          setLoading,
          setNext,
          setPrevious,
        ),
      )
    }
  }, [fechaDesde, fechaHasta, sortBy, id, page, limit, verDetalle])

  useEffect(() => {
    if (isNew) {
      //Iniciamos presupuesto
      let presupuesto = {}
      //Cargamos lineas de pedido
      const lineasPedido = []
      if (pedido?.lineas?.length > 0) {
        for (const linea of pedido.lineas) {
          lineasPedido.push({
            articulo: linea.articulo,
            presentacion: linea.presentacion_escogida || linea.presentacion_pedido,
            descripcion: linea.descripcion,
            precio_origen: linea.precio_venta,
            dto_origen: linea.dto_4 || 0, //TODO: Estandarizar
            tipo: null,
            cantidad: Number(linea.cantidad_pedida),
            dto_cargo: 0,
            precio: Number(linea.precio_neto).toFixed(precios.decimales_precios || 2),
            precio_iva: Number(linea.importe_neto_lin_impuestos / linea.cantidad_pedida).toFixed(
              precios.decimales_precios || 2,
            ), //TODO: real?
            selected: true,
          })
        }
      }

      //Cargamos datos cabecera
      if (presupuestos?.length === 1) {
        presupuesto = presupuestos[0]
        setIsSaved(true)
      } else {
        presupuesto['id_pedido'] = pedido.id_pedido
        presupuesto['datos_cliente'] = ''
        presupuesto['datos_emisor'] = ''
        presupuesto['pie_presupuesto'] = ''
      }
      presupuesto.lineas = lineasPedido

      setPresupuestoSeleccionado(presupuesto)
    }
  }, [presupuestos])

  const devolverImporteLineas = presupuesto => {
    return presupuesto?.lineas
      ?.reduce(
        (totalPedido, lin) => Number.parseFloat(totalPedido) + Number.parseFloat(lin.precio || 0),
        0,
      )
      .toFixed(precios.decimales_precios || 2)
  }

  const handleChangeFilters = (newID, newFechaDesde, newFechaHasta, newSortBy) => {
    if (
      id !== newID ||
      fechaDesde !== newFechaDesde ||
      fechaHasta !== newFechaHasta ||
      sortBy !== newSortBy
    ) {
      setPage(1)
      setPresupuestos([])

      setID(newID)
      setFechaDesde(newFechaDesde)
      setFechaHasta(newFechaHasta)
      setSortBy(newSortBy)
    }
  }

  const handleSortByChange = newOrdernarPor => {
    setPage(1)
    setSortBy(newOrdernarPor)
  }

  const handleVerDetalle = () => {
    setVerDetalle(false)
    setIsSaved(false)
    setPresupuestoSeleccionado()
  }

  return !verDetalle ? (
    <Box sx={{ padding: 4 }}>
      {/* Título */}
      <Typography
        variant='h4'
        className={'titulo-webpresupuestos'}
        sx={{ fontWeight: 'bold !important' }}
        gutterBottom>
        {i18n.t('webpresupuestos.wptitgn')}
      </Typography>

      {/* Barra de búsqueda */}
      <WebPresupuestosFilters
        loader={loading}
        handleClick={handleChangeFilters}
        handleSortByChange={handleSortByChange}
      />
      {/* Tabla de presupuestos */}
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow className={'titulos-webpresupuestos'}>
              <TableCell
                className={'celda-titulos'}
                sx={{ fontWeight: 'bold', backgroundColor: '#1976d2', color: 'white' }}>
                {i18n.t('webpresupuestos.wpid')}
              </TableCell>
              <TableCell
                className={'celda-titulos'}
                sx={{ fontWeight: 'bold', backgroundColor: '#1976d2', color: 'white' }}>
                {i18n.t('webpresupuestos.wpfecha')}
              </TableCell>
              <TableCell
                className={'celda-titulos'}
                sx={{ fontWeight: 'bold', backgroundColor: '#1976d2', color: 'white' }}>
                {i18n.t('webpresupuestos.wpnumlin')}
              </TableCell>
              <TableCell
                className={'celda-titulos'}
                sx={{ fontWeight: 'bold', backgroundColor: '#1976d2', color: 'white' }}>
                {i18n.t('webpresupuestos.wptot')}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={4}>
                  <Spinner showSpinner={loading} />
                </TableCell>
              </TableRow>
            ) : presupuestos?.length > 0 ? (
              presupuestos.map(presupuesto => (
                <TableRow
                  className={'datos-webpresupuestos'}
                  sx={{
                    cursor: 'pointer',
                    '&:hover': {
                      fontWeight: 'bold',
                    },
                  }}
                  key={presupuesto.id_pedido}
                  onClick={e => {
                    e.preventDefault()
                    setIsSaved(true)
                    setPresupuestoSeleccionado(presupuesto)
                    setVerDetalle(true)
                  }}>
                  <TableCell
                    className={'celda-datos'}
                    sx={{ fontWeight: 'inherit !important' }}>
                    {presupuesto.id_pedido}
                  </TableCell>
                  <TableCell
                    className={'celda-datos'}
                    sx={{ fontWeight: 'inherit !important' }}>
                    {presupuesto.fecha}
                  </TableCell>
                  <TableCell
                    className={'celda-datos'}
                    sx={{ fontWeight: 'inherit !important' }}>
                    {presupuesto.lineas.length}
                  </TableCell>
                  <TableCell
                    className={'celda-datos'}
                    sx={{ fontWeight: 'inherit !important' }}>
                    {devolverImporteLineas(presupuesto)}
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={4}>
                  <span style={{ width: '100%', justifyContent: 'center', display: 'flex' }}>
                    {i18n.t('webpresupuestos.wpnodata')}
                  </span>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {!loading && numeroRegistros > limit && (
        <Paginator
          previous={previous}
          next={next}
          loading={loading}
          totalRecords={numeroRegistros}
          recordsPerPage={limit}
          maxVisibleButtons={3}
          page={page}
          setPage={setPage}
        />
      )}
    </Box>
  ) : (
    <WebPresupuestosDetalle
      presupuesto={presupuestoSeleccionado}
      handleVerDetalle={handleVerDetalle}
      loading={loading}
      isNew={isNew}
      isSaved={isSaved}
    />
  )
}

export default WebPresupuestos
